import { Skeleton } from '@/components/ui/skeleton'
import { currentBoardExistsSelector, getSelectedBoardId } from '@common-reducers/BoardsSelectors'
import { handleActiveBulkViewNavigationThunk } from '@common-reducers/CampaignThunks'
import { isTempId } from "@common-reducers/DBServiceThunks"
import { useAppDispatch, useAppSelector } from '@common-reducers/hooks/store.hook'
import { useRouter } from '@common-reducers/hooks/use-router'
import { isExtensionContextOrWhatsappView } from '@common-services/detect-context'
import { CAMPAIGN_PATHS } from '@common/utils/campaign-routes'
import { useCampaignsRedesignNav } from '@extension/context/content/components/campaigns-redesign/nav-context'
import TaskView from '@common-views/task-view/task-view'
import { useMemo } from 'react'


export default function BulkTaskViewContainer() {
    const dispatch = useAppDispatch()
    const router = useRouter()
    // Non-null under the redesign shell → the board's BACK button returns to the
    // Audiences tab URL. Null for legacy/extension → existing Redux/router back.
    const redesignNav = useCampaignsRedesignNav()

    const selectedBoardId = useAppSelector(getSelectedBoardId);
    const isCurrentBoardExists = useAppSelector(currentBoardExistsSelector);
    const activeBulkView = useAppSelector((state) => state.CampaignReducer.activeBulkView);


    const isBoardReadyToDisplay = useMemo(() => {
        const isReady = selectedBoardId && !isTempId(selectedBoardId) && isCurrentBoardExists;
        return isReady
    }, [selectedBoardId, isCurrentBoardExists])




    return (
        <>
            {isBoardReadyToDisplay &&
                <div className="flex flex-col w-full h-screen bg-[var(--color-bg)] dark:bg-[var(--color-bg)]">
                    <TaskView
                        isDisplaySharedUsersAvatar={false}
                        isDisplayShareButton={false}
                        isDisplayMenuButton={false}
                        isDisplayDarkBrightModeButton={false}
                        isDisplayTabs={false}
                        isDisplayTasksPanelHeader={true}
                        isDisplayNewGroupButton={false}
                        isDisplaySearchField={true}
                        isDisplayPersonButton={false}
                        isDisplayColumnsButton={true}
                        isDisplayImportButton={true}
                        isDisplayExportButton={true}
                        isDisplayBoardPanel={false}
                        isDisplayUpgradeButton={false}
                        isDisplayActivityButton={false}
                        isDisplayNotificationsButton={false}
                        isFromCampaign={true}
                        taskViewTheme="lean"
                        isDisplayBackButton={true}
                        backTooltip="Back to Manage Audiences"
                        onBackClick={() => {
                            // Redesign: URL-drive back to the Audiences tab list (reload-safe).
                            if (redesignNav) {
                                redesignNav.closeBoard()
                                return
                            }
                            // Website only: return to the audiences tab URL when leaving a board
                            // opened from the management view. The new-campaign wizard board has
                            // no URL, so it just unwinds its Redux view.
                            if (activeBulkView === "campaignBoardFromManagementView" && !isExtensionContextOrWhatsappView()) {
                                router.navigate(CAMPAIGN_PATHS.manageAudiences)
                            }
                            dispatch(handleActiveBulkViewNavigationThunk({ navigate: "fromCampaignBoardView" }))
                        }}
                    />
                </div>
            }
            {!isBoardReadyToDisplay && (
                <div className="flex flex-row justify-center items-center w-full h-screen bg-[var(--color-bg)] dark:bg-[var(--color-bg)]">
                    <div className="flex flex-col gap-2">
                        <Skeleton className="h-4 w-[250px]" />
                        <Skeleton className="h-4 w-[200px]" />
                        <Skeleton className="h-4 w-[230px]" />
                    </div>
                </div>
            )}
        </>
    )
}